import React, { useEffect, useState } from 'react';
import { PostBox } from 'pages/home/Home.style';
import { JobCreateStyles } from 'pages/jobs/JobPosts.style';
import JobCreate from 'pages/jobs/JobCreate';
import Preview from 'pages/jobs/Preview';
import { useLocation } from 'react-router-dom';
import {
  getCategoryList,
  getCountryList,
  getJobTypeList,
  getWorkTypeList,
} from 'redux/features/DropDownSlice';

import { ReactComponent as JobCreateIcon } from 'assert/images/Jobs/jobCreate.svg';
import { ReactComponent as JobPublishIcon } from 'assert/images/Jobs/jobPublish.svg';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { getJobPostById } from 'redux/features/PostJobSlice';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const currentState = {
  jobTitle: '',
  // categoryId: '',
  yearOfExperience: '',
  jobTypeIds: [],
  workTypeIds: [],
  salary: '',
  location: [],
  jobDescription: '',
  link: '',
  preTemplate: '',
  template: [],
  companyName: '',
  companySize: '',
  companyWebsite: '',
  companyLogo: [],
  companyDescription: '',
  attachment: [],
};

function JobPostForm() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const postid = params.get('postid');
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { categoryList, jobList, workTypeList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );
  const jobDetail = useSelector(
    (state) => state?.PostJobReducer?.jobDetailview
  );
  const jobData = jobDetail;
  const [current, setCurrent] = useState(0);
  const [isDisablePreview, setIsDisablePreview] = useState(true);
  const [state, setState] = useState({ ...currentState });

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      ...jobData,
      companyLogo: jobData?.companyLogo ? [jobData.companyLogo] : [],
      location: jobData?.location || [],
      template: [],
      workTypeIds: jobData?.workTypeIds
        ? jobData?.workTypeIds?.split(',').map(Number)
        : [],
      jobTypeIds: jobData?.jobTypeIds
        ? jobData?.jobTypeIds?.split(',').map(Number)
        : [],
    }));
  }, [jobDetail]);

  useEffect(() => {
    postid && dispatch(getJobPostById(postid));
  }, [postid]);

  useEffect(() => {
    window.scroll(0, 0);
    categoryList?.length === 0 && dispatch(getCategoryList());
    jobList?.length === 0 && dispatch(getJobTypeList());
    workTypeList?.length === 0 && dispatch(getWorkTypeList());
    countryList?.length === 0 && dispatch(getCountryList());
    setState(currentState);
  }, []);

  useEffect(() => {
    if (current === 1) {
      if (typeof state.companyLogo?.[0] !== 'string' && jobData?.companyLogo) {
        state.attachment = [jobData?.companyLogo];
        setState((prevState) => ({
          ...prevState,
        }));
      }
    }
  }, [current]);

  // const beforeunloadHandler = useCallback(
  //   (e) => {
  //     if (
  //       JSON.stringify(initialState) !== JSON.stringify(state) ||
  //       current === 1
  //     ) {
  //       e.preventDefault();
  //       e.returnValue = '';
  //     }
  //   },
  //   [initialState, state]
  // );

  // useEffect(() => {
  //   window.addEventListener('beforeunload', beforeunloadHandler);
  //   return () => {
  //     window.removeEventListener('beforeunload', beforeunloadHandler);
  //   };
  // }, [beforeunloadHandler]);

  return (
    <>
      <Helmet>
        <title>
          Post Job | WafyNet - Post Your Job for Free and Hire Talent
        </title>
        <meta
          name="description"
          content="Post a job on WafyNet and connect with talented candidates. Find the right professionals for your company's hiring needs today."
        />
      </Helmet>
      <JobCreateStyles>
        <PostBox>
          <div className="custom-job-steps">
            <div className="job-step" onClick={() => setCurrent(0)}>
              <div className="job-step-icon job-form-icon">
                <JobCreateIcon />
              </div>
              <div className="job-form-title">{t('Job.Form')}</div>
            </div>
            <div
              className={clsx(
                'job-step-hr-line',
                isDisablePreview && 'disable'
              )}
            />
            <div
              className={clsx('job-step', isDisablePreview && 'disable')}
              onClick={isDisablePreview ? () => {} : () => setCurrent(1)}
            >
              <div
                className={clsx(
                  'job-step-icon job-publish-icon',
                  isDisablePreview && 'disable'
                )}
              >
                <JobPublishIcon />
              </div>
              <div className="job-publish-title">
                {t('Job.PreviewAndPublish')}
              </div>
            </div>
          </div>
          {current === 0 && (
            <JobCreate
              onChangeTab={setCurrent}
              state={state}
              setState={setState}
              setIsDisablePreview={setIsDisablePreview}
              jobDetail={jobDetail}
            />
          )}
          {current === 1 && (
            <Preview
              onChangeTab={setCurrent}
              postid={postid}
              state={state}
              fieldReset={() => setState(currentState)}
              jobPostPreview={true}
            />
          )}
        </PostBox>
      </JobCreateStyles>
    </>
  );
}

export default JobPostForm;
